import React, { useState } from "react";
import "../../Stylesheets/Navbar/Navbar.scss";
import Logo from "../../assests/Images/Navbar/Codoid-Logo-01.svg";
import codoid_logo from "../../assests/Images/Banner/codoid_icon.png"
const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = element.clientHeight / 2; // Adjust this value based on your needs
      let add_px = 0
      if (id=="testimonials_go_to"){
        add_px = 240
      }else if(id=="deliver"){
        add_px = 190
      }else if(id=="contact_us_goto"){
        add_px=195
      }
      window.scrollTo({
        top: element.offsetTop - offset +add_px,
        behavior: 'smooth',
      });
    }
  };
  return (
    <div className="navbar-main-wrapper">
      <div className="navbar-inner-wrapper">
        <div className="logo-wrap">
          <img src={codoid_logo} alt="Codoid-Logo" className="codoid-logo" />
        </div>

        <div className={`navbar-options-wrap${showSidebar ? " active" : ""}`}>
          <ul className="nav-options">
            {/* <li className="nav-list"><a  href="#main_page_banner" onClick={() => scrollToSection('main_page_banner')}>Home</a></li>
            <li className="nav-list" ><a  onClick={() => scrollToSection('deliver')}>About Us</a></li>
            <li className="nav-list"><a  onClick={() => scrollToSection('testimonials_go_to')}>Testimonials</a></li> */}
            <li className="nav-list">
            <a onClick={() => scrollToSection('contact_us_goto')}><button className="contact-btn">Contact Us</button></a>
            </li>
          </ul>
        </div>

        {/* <div className="hamburger-menu" onClick={toggleSidebar}>
          <div className={`bar ${showSidebar ? "change" : ""}`}></div>
          <div className={`bar ${showSidebar ? "change" : ""}`}></div>
          <div className={`bar ${showSidebar ? "change" : ""}`}></div>
        </div> */}
      </div>
    </div>
  );
};

export default Navbar;
